import calculateIndexMap from "./calculateIndexMap";
import calculateIndexMap2 from "./calculateIndexMap2";
/*

This function will split array into n(no of columns) parts.

*/
const horizontalSplit = (items, options) => {
    const n = Math.floor(items.length / options.columns);
    const extra = items.length - n * options.columns;

    const middle = options.columns%2===0?(options.columns / 2)+1:Math.ceil(options.columns / 2);
    const indexMap = options.balance_columns?calculateIndexMap(extra, middle):calculateIndexMap2(extra,middle);
    let [...arr] = items;
    
    const columns=options.columns;
    let res ={
        
    }
    for (let index = 0; index < columns; index++) {
        res[index]=[]
        
    }
    let total=items.length
    let j=0;
    let len=arr.length
    while(len){
           if(total-columns>=0){
               for(let i=0;i<columns;i=i+1){
                   res[i].push(arr[j])
                   j++;
                   len--;
                   
               }
               total=total-columns
           }
           else{
            for(let i=0;i<columns;i=i+1){
                if(indexMap[i+1]===true){
                res[i].push(arr[j])
                j++
                len--;
                }
            }
           }
            
    }
    let ans=[]
    Object.keys(res).forEach(key=>{
        ans.push(res[key])
    })
    return {ans,indexMap}
  }
export default horizontalSplit  